import _objectAssign from './_objectAssign';

export default typeof Object.assign === 'function' ? Object.assign : _objectAssign;


//////////////////
// WEBPACK FOOTER
// ./~/vue-ramda/~/ramda/es/internal/_assign.js
// module id = 314
// module chunks = 1